import React from 'react';
import { Box } from '@mui/material';
import {TextFieldWithHeader} from "../textField/TextFieldWithHeader";

type AgentFormProps = {
    agentName: string;
    playbookName: string;
    goal: string;
    instructions: string;
    setAgentName: (name: string) => void;
    setPlaybookName: (name: string) => void;
    setGoal: (goal: string) => void;
    setInstructions: (instructions: string) => void;
    onChangeDetected: () => void;
};

const AgentForm: React.FC<AgentFormProps> = ({
         agentName,
         playbookName,
         goal,
         instructions,
         setAgentName,
         setPlaybookName,
         setGoal,
         setInstructions,
         onChangeDetected,
     }) => {
    return (
        <Box
            component="form"
            p={2}
            sx={{
                '& > :not(style)': { mb: 2 },
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}
            noValidate
            autoComplete="off"
        >
            <TextFieldWithHeader
                fullWidth
                id="name-agent-input"
                header="Name des Agenten"
                value={agentName}
                onChange={(event) => {
                    setAgentName(event.target.value);
                    onChangeDetected();
                }}
            />
            <TextFieldWithHeader
                fullWidth
                id="name-playbook-input"
                header="Name des Playbooks"
                value={playbookName}
                onChange={(event) => {
                    setPlaybookName(event.target.value);
                    onChangeDetected();
                }}
            />
            <TextFieldWithHeader
                id="goals-input"
                header="Ziele"
                multiline
                fullWidth
                minRows={10}
                value={goal}
                onChange={(event) => {
                    setGoal(event.target.value);
                    onChangeDetected();
                }}
            />
            <TextFieldWithHeader
                id="instructions-input"
                header="Anweisungen"
                multiline
                fullWidth
                minRows={10}
                value={instructions}
                onChange={(event) => {
                    setInstructions(event.target.value);
                    onChangeDetected();
                }}
            />
        </Box>
    );
};

export default AgentForm;